import { Box, CircularProgress, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

// Popup landing page for the Google Business Profile OAuth redirect. Reads ?code & ?state, posts them
// back to the opener window (GoogleBusinessSettings), and closes itself.
export default function GoogleBusinessOAuthCallback() {
  const [message, setMessage] = useState('Finishing sign-in…')

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const code = params.get('code')
    const state = params.get('state')
    const error = params.get('error')

    try {
      if (window.opener) {
        window.opener.postMessage(
          { type: 'google-business-oauth', code: code || '', state: state || '', error: error || '' },
          window.location.origin,
        )
        setMessage(error ? 'Sign-in was cancelled. You can close this window.' : 'Connected. You can close this window.')
        setTimeout(() => window.close(), 400)
      } else {
        setMessage('This window was opened outside the app. Please close it and try connecting again.')
      }
    } catch (e) {
      setMessage('Something went wrong. Please close this window and try again.')
    }
  }, [])

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        p: 3,
      }}
    >
      <CircularProgress size={26} />
      <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>
        {message}
      </Typography>
    </Box>
  )
}
